import React from "react";
import "./common.scss";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const NotificationPopup = ({ heading, content, image, setNotification }) => {
  const role = useSelector(
    (state) => state?.authReducer?.tokenData?.user?.role
  );
  const normalizedRole = typeof role === "string" ? role.toLowerCase() : role;
  const navigate = useNavigate();
  const handleNotificationClick = () => {
    setNotification(null);
    if (normalizedRole === "merchant") {
      navigate("/merchant/offer-list");
    } else if (normalizedRole === "fundraiser") {
      navigate("/fundraiser/referral-list");
    } else {
      navigate("/admin/offer-list");
    }
  }

  return (
    <div className="notification-container cursor-pointer" onClick={handleNotificationClick}>
      <div className="relative flex flex-col justify-center gap-2 items-center w-[335px] sm:w-[420px] min-h-[120px] bg-white rounded-[12px] shadow-[0_6px_20px_rgba(0,173,239,0.25)] border border-[#00ADEF4D] popup">
        {image !== null && <img src={image} className="w-[40px] h-[40px] mt-2" alt="notification"/>}
        <div className="flex flex-col justify-center items-center sm:gap-1 px-4 pb-3">
          <p className="text-[16px] sm:text-[18px] font-[600] font-montserrat text-[#00ADEF] text-center">
            {heading}
          </p>
          <p className="text-[12px] sm:text-[13px] font-[500] font-montserrat text-[#303030] text-center">
            {content}
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotificationPopup;
